import { prepare, layout } from "@chenglou/pretext"

const VanillaFittty = (scope?: HTMLElement) => {
  ;(scope || document).querySelectorAll<HTMLElement>("[data-fittty]").forEach(el => {
    const containerEl = el
    if (containerEl.clientHeight === 0) return

    const innerEl = containerEl.children[0] as HTMLElement
    if (!innerEl) return

    const text = innerEl.textContent || ""
    if (!text) return

    const mode = el.dataset.fitttyMode || "box"
    const computed = getComputedStyle(innerEl)
    const fontFamily = computed.fontFamily
    const fontWeight = computed.fontWeight
    const containerWidth = containerEl.clientWidth
    const containerHeight = containerEl.clientHeight

    let minFs = Number(el.dataset.fitttyMin) || 20
    let maxFs = Number(el.dataset.fitttyMax) || 52
    const precision = 0.1

    while (maxFs - minFs > precision) {
      const mid = (minFs + maxFs) / 2
      const font = `${fontWeight} ${mid}px ${fontFamily}`
      const prepared = prepare(text, font)
      const lineHeight = mid * 1.2

      if (mode === "oneline") {
        const { lineCount } = layout(prepared, containerWidth, lineHeight)
        if (lineCount <= 1) {
          minFs = mid
        } else {
          maxFs = mid
        }
      } else {
        const { height } = layout(prepared, containerWidth, lineHeight)
        if (height <= containerHeight) {
          minFs = mid
        } else {
          maxFs = mid
        }
      }
    }

    innerEl.style.fontSize = `${minFs}px`

    // Avoid to reprocess same card again
    el.removeAttribute("data-fittty")
  })

  window.dispatchEvent(new CustomEvent("VanillaFittty", {}))
}

export default VanillaFittty
